import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const RegisterPage = ({ onToggle }) => {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', password: '', org: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setSubmitting(true);
    try {
      const result = await register(form);
      if (!result.success) setError(result.error);
      else setSuccess(true);
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <img src="/cenec-logo.svg" alt="CENEC" />
            <span className="auth-subtitle">Network Resource Grid</span>
          </div>
          <div className="auth-form">
            <h2>Registration Successful</h2>
            <p style={{ color: 'var(--cenec-green)', margin: '16px 0' }}>
              Your account has been created. You can now sign in.
            </p>
            <button className="btn-primary" onClick={onToggle}>Go to Sign In</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/cenec-logo.svg" alt="CENEC" />
          <span className="auth-subtitle">Network Resource Grid</span>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Register</h2>
          {error && <div className="auth-error">{error}</div>}
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="John Doe"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="you@company.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Organisation</label>
            <input
              type="text"
              value={form.org}
              onChange={(e) => setForm({ ...form, org: e.target.value })}
              placeholder="CENEC"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Min 6 characters"
              required
            />
          </div>
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Registering...' : 'Register'}
          </button>
          <p className="auth-link">
            Already have an account?{' '}
            <button type="button" onClick={onToggle}>Sign In</button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
